module.exports = "images/france-5.a8ef4f1e.png";